import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { accountsClient } from '../../../../utils/apollo/api'
import { assocOrDissocValue } from '../../../../utils/helpers/requestCleaner'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertProfile($input: ProfileInput) {
    upsertProfile(input: $input) {
      id
    }
  }
`

const cleanRequest = item =>
  compose(
    pick(['id', 'name', 'label', 'parentId']), //
    assoc('name', !item.id ? item.label : item.name),
    assocOrDissocValue('parentId', item.parent?.id)
  )(item)

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.label, { path: ['label'], message: 'Campo obrigatório' }),
    ...appendIf(!form.id && !form.parent?.id, { path: ['parent'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveProfile = () => {
  const closeModal = useCloseModal()

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Profiles', 'Permissions'],
    client: accountsClient
  })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
